import { AfterViewInit, Directive, ElementRef, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { unpatchAddEventListener } from '@rx-angular/cdk/zone-less/browser';
import { getParentsUntil } from '@utils/dom/element';
import { stopAndPreventEvent } from '@utils/dom/event';
import { capitalize } from '@utils/string';
import { DEFAULT_IDENTITTY } from '../constants';
import { HighlightMeController } from '../services';

@Directive({
  selector: '[highlightMeScene]',
  standalone: true
})
export class HighlightMeSceneDirective implements OnInit, AfterViewInit, OnDestroy {

  @Input()
  get identity(): string { return this.#identity; }
  set identity(identity: string) { this.#identity = identity; }
  #identity: string = DEFAULT_IDENTITTY;

  @Input()
  get alias(): string { return this.#alias; }
  set alias(alias: string) { this.#alias = alias; }
  #alias = 'entity';

  #elementRef = inject(ElementRef);
  #controller = inject(HighlightMeController);

  constructor() { }

  get domElement(): HTMLElement { return this.#elementRef.nativeElement; }

  ngOnInit() {
    this.#controller.connect(this);
  }

  ngAfterViewInit() {
    unpatchAddEventListener(this.domElement);

    this.domElement.addEventListener('mouseover', this.onMouseOver.bind(this));
    this.domElement.addEventListener('mouseout', this.onMouseOut.bind(this));
  }

  ngOnDestroy() {
    this.#controller.disconnect(this);
  }

  private onMouseOver(event: MouseEvent) {
    this.highlightActor(event, true);
    stopAndPreventEvent(event);
  }

  private onMouseOut(event: MouseEvent) {
    this.highlightActor(event, false);
    stopAndPreventEvent(event);
  }

  private highlightActor(event: MouseEvent, on: boolean) {
    const dataSetSelector = `[data-${this.#alias}-${this.#identity}]`;
    const dataSetKey = `${this.#alias}${capitalize(this.#identity as any, true)}`;
    const parentElementTarget: HTMLElement[] = getParentsUntil((event.target as HTMLElement), dataSetSelector);

    if (parentElementTarget[0] && parentElementTarget[0].dataset[dataSetKey]) {
      this.#controller.highlightActor(parentElementTarget[0].dataset[dataSetKey], on);
    }
  }
}
